
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bluerex",
      function () {
        return require("private-next-pages/bluerex.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bluerex"])
      });
    }
  